import { ContractorModel, ContractorModelAPI } from '../../../../models';

export const getContractorsListAdapter = (
    responseAPI: ContractorModelAPI[]
): ContractorModel[] => {
    return responseAPI
        ? responseAPI.map((contractor) => {
              return {
                  id: contractor.id,
                  commercialName: contractor.commercialName,
                  companyId: contractor.companyId,
              };
          })
        : [];
};
